import {Image, Box, Center} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

export function PriceReportWidgetLogo(props: TestIdProps) {
  return (
    <ImageBackground>
      <Center width="100%" height="100%">
        <Box width="66%" height="66%">
          <Image
            data-testid={suffixTestId('priceReportWidgetLogo', props)}
            src="assets/images/price_report_logo.svg"
            width="100%"
            height="100%"
            fit="contain"
          />
        </Box>
      </Center>
    </ImageBackground>
  );
}

const ImageBackground = styled.div`
  background: linear-gradient(0deg, rgb(62, 71, 221) 0%, rgb(38, 42, 152) 100%);
  width: 100%;
  height: 100%;
`;
